module.exports = __webpack_public_path__ + "static/img/icon0.e661b22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon0.jpg
// module id = d43Z
// module chunks = 0